import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/todo-page/header';

Component('tr-todo-page-header', {
  mixins: [eventListenerMixin],

  connected() {
    $(this).on('ajax:success', '.run-button', this.handleRunTodo.bind(this))
      .on('ajax:success', '.pause-button', this.handlePauseTodo.bind(this));
  },

  handleRunTodo(event) {
    event.stopPropagation();
    this.classList.add('running');
    this.namespacedTrigger('run', { bubbles: true });
  },

  handlePauseTodo(event) {
    event.stopPropagation();
    this.classList.remove('running');
    this.namespacedTrigger('pause', { bubbles: true });
  },

  disconnected() {
    this.stopListening();
    $(this).off();
  },
});
